<template>
  <b-tab
    v-if="groupSessionData && $can('read', 'group-session')"
    title="Group Sessions"
  >
    <b-card>
      <div class="mb-3">
        <p><strong>Created At:</strong> {{ formatDate(groupSessionData.createdAt) }}</p>
        <p><strong>Status:</strong> {{ snakeCaseToCamelCase(groupSessionData.status) }}</p>
      </div>

      <b-table
        v-if="groupSessionData.members"
        striped
        bordered
        :items="membersArray"
        :fields="fields"
      >
        <template #cell(actions)="data">
          <b-button
            class="btn-icon rounded-circle"
            variant="flat-primary"
            @click="$router.push(`/users/${data.item.userId}?externalId=${data.item.externalId}`)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button>
        </template>
      </b-table>
    </b-card>
  </b-tab>
</template>

<script>
import {
  inject, ref, onMounted, computed,
} from '@vue/composition-api'
import {
  BTab, BTable, BCard, BButton,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import formatDate from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'

export default {
  components: {
    BTab,
    BButton,
    BCard,
    BTable,
  },
  setup() {
    const trip = inject('trip')
    const groupSessionId = trip.value?.group_session_id
    const groupSessionData = ref(null)

    const fetchGroupSession = async () => {
      try {
        const res = await axiosIns.get(`/group-sessions/${groupSessionId}`)
        groupSessionData.value = res.data.data
      } catch (error) {
        console.error('Failed to fetch group session data:', error)
      }
    }

    onMounted(() => {
      if (groupSessionId) {
        fetchGroupSession()
      }
    })

    // Convert members object to array for table display
    const membersArray = computed(() => (groupSessionData.value?.members
      ? Object.values(groupSessionData.value.members)
      : []))

    const fields = [
      { key: 'phoneNumber', label: 'Phone Number' },
      {
        key: 'discountKey',
        label: 'Discount Amount',
        formatter: (_, _2, val) => val.price.discount_amount,
      },
      {
        key: 'discountAmount',
        label: 'Discount Percentage',
        formatter: (_, _2, val) => val.price.discount,
      },
      {
        key: 'amountAfterDiscount',
        label: 'Amount after discount',
        formatter: (_, _2, val) => val.price.amount_after_discount,
      },
      // {
      //   key: 'tripState',
      //   label: 'Trip State',
      //   formatter: val => snakeCaseToCamelCase(val),
      // },
      'actions',
    ]

    return {
      groupSessionData,
      membersArray,
      fields,
      formatDate,
      snakeCaseToCamelCase,
    }
  },
}
</script>
